<template>

    <v-card :loading="loading" :disabled="loading">

        <v-card-title class="headline grey darken-4">
            Conferencia de recebimento</v-card-title>
        <v-card-text class="pt-4">
            <v-container>
                <v-row>
                    <v-col cols="12">
                        <Input type="number" v-model="access_key" @keydown.enter="checkKey(access_key)"></Input>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </v-card>
</template>

<script>
    import { mapActions } from "vuex";
    export default {

        data() {
            return {
                loading: false,
                access_key: "",
            };
        },

        methods: {
            ...mapActions("print", ["printConference"]),

            checkKey(access_key) {
                this.loading = true;
                this.printConference(access_key).then((response) => {
                    this.$emit('close-dialog');
                }).finally(() => {
                    this.loading = false;
                });
            },
        },
    };
</script>